
import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Workorder, CostLabor, CostsApi } from 'performo-api';

import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';

import AddLaborComponent from '@/components/orders/AddLaborComponent.vue';
import DeleteCostLabor from '@/components/orders/DeleteCostLabor.vue';
import UpdateCostLabor from '@/components/orders/UpdateCostLabor.vue';

import { User } from 'oidc-client';

@Component({
  components: {
    AddLaborComponent,
    DeleteCostLabor,
    UpdateCostLabor
  },
  computed: mapGetters({
    costsApi: 'costsApi',
    currentUser: 'currentUser'
  })
})
export default class OrderLaborListComponent extends Vue {
  @Prop({ required: true })
  private order!: Workorder;

  private currentUser!: User;
  private costsApi!: CostsApi;

  get costLaborDisplayOptions(): ColumnDisplayOption[] {
    return [
      { displayName: 'Labor/Trade', columnName: 'laborName', dontSort: true },
      {
        displayName: 'Labor Date',
        columnName: 'laborDate',
        dateFormatKind: 1,
        dontSort: true
      },
      {
        displayName: 'Hours',
        columnName: 'laborHours',
        width: '50px',
        dontSort: true,
        formatter: (f: number) => {
          if (f) return f.toFixed(2);
          else return '';
        }
      },
      {
        displayName: 'Actions',
        columnName: 'laborAction',
        width: '20px',
        dontSort: true
      }
    ];
  }

  private async laborAddedHandler(labor: CostLabor) {
    this.$emit('labor-added', labor);
  }

  private async laborUpdatedHandler() {
    this.$emit('labor-updated');
  }

  private laborDeletedHandler() {
    this.$emit('labor-deleted');
  }
}
